import { render, staticRenderFns } from "./DelegationManager.vue?vue&type=template&id=1941282c&scoped=true&"
import script from "./DelegationManager.vue?vue&type=script&lang=js&"
export * from "./DelegationManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941282c",
  null
  
)

export default component.exports